import getReduxStore from '../app/redux/getReduxStore';
import { isElectron } from '../utils/desktopClient';
import getRedirectQueryString from './getRedirectQueryString';
import { SessionActions } from './sessionSlice';

const IGNORE_LOCAL_LOGOUT_TIMESTAMP = 'ignoreLocalLogoutTimestamp';
const THRESHOLD_SECONDS = 60;

export function shouldIgnoreLocalLogout(): boolean {
  try {
    const ignoreLocalLogoutTimestamp = parseInt(
      localStorage.getItem(IGNORE_LOCAL_LOGOUT_TIMESTAMP) ?? '0',
      10,
    );

    const isWithinTimeframe =
      Date.now() - ignoreLocalLogoutTimestamp <= THRESHOLD_SECONDS * 1000;

    if (!isWithinTimeframe) {
      localStorage.removeItem(IGNORE_LOCAL_LOGOUT_TIMESTAMP);
    }

    return isWithinTimeframe;
  } catch (e) {
    return false;
  }
}

export function ignoreNextLocalLogout() {
  localStorage.setItem(IGNORE_LOCAL_LOGOUT_TIMESTAMP, Date.now().toString());
}

export default (includeRedirect = true) => {
  const { pathname } = document.location;
  getReduxStore().dispatch(SessionActions.clearSession());
  if (pathname !== '/login') {
    if (isElectron) {
      window.desktop?.logout?.();
    } else if (pathname !== '/deleted') {
      const redirectSearch = includeRedirect ? getRedirectQueryString() : '';

      document.location.href = `/login${redirectSearch}`;
    }
  }
};
